import { render } from "./Wedo.vue?vue&type=template&id=97a2e70e&scoped=true&ts=true"
import script from "./Wedo.vue?vue&type=script&lang=ts"
export * from "./Wedo.vue?vue&type=script&lang=ts"

import "./Wedo.vue?vue&type=style&index=0&id=97a2e70e&scoped=true&lang=css"
import "./Wedo.vue?vue&type=style&index=1&id=97a2e70e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a2e70e"]])

export default __exports__